import { Box, styled, Typography } from '@mui/material';
import { Plus } from '@styled-icons/bootstrap/Plus';
import { Search } from '@styled-icons/bootstrap/Search';
import spark from 'assets/img/spark.png';
import ThemeButton from 'DesignSystem/Buttons/ThemeButton/ThemeButton';
import CardContainer from 'DesignSystem/Layout/CardContainer/CardContainer';
import React, { FC } from 'react';

interface IEmptySearchResultsProps {
  message?: string;
  action?: {
    label: string;
    dataTestId?: string;
    onClick: () => void;
  };
  skeletonComponent: React.ReactNode;
}

const Text = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: 20,
}));

const HeadlineContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.grey[500],
  marginBottom: theme.spacing(5),
}));

const Container = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '40%',
  left: '50%',
  transform: 'translate3d(-50%, -50%, 0)',
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.text.secondary,
  minWidth: 400,
}));

const Spark = styled('img')(() => ({
  position: 'absolute',
  width: 60,
  height: 60,
  right: -35,
  top: -25,
}));

const ListItemContainer = styled('div')(() => ({
  position: 'relative',
  display: 'flex',
}));

const EmptySearchResults: FC<IEmptySearchResultsProps> = ({
  message = 'There is nothing here yet.',
  action,
  skeletonComponent: Skeleton,
}) => {
  return (
    <Container>
      <HeadlineContainer>
        <Box mr={2}>
          <Search size={25} />{' '}
        </Box>
        <Text>{message}</Text>
      </HeadlineContainer>
      <ListItemContainer>
        <CardContainer padding={1.5} maxWidth="550px">
          {Skeleton}
        </CardContainer>
        <Spark src={spark} />
      </ListItemContainer>
      {action?.onClick && (
        <Box mt={2}>
          <ThemeButton
            data-testid={action.dataTestId}
            onClick={action.onClick}
            color="BLUE_ICE"
            startIcon={<Plus size={20} color="white" />}
          >
            {action.label}
          </ThemeButton>
        </Box>
      )}
    </Container>
  );
};

export default EmptySearchResults;
